import common from "../common";
import Scene from "./Scene";

export default class PreloaderScene extends Scene {
    constructor() {
        super();

        this.loaded = 0;

        this._barWidth = 420;

        this.fonts = [
            {font:'oswaldregular', fontText:null, fontLoaded:false}
         ];
    }

    init() {
        super.init();

        //ensure font is loaded
        this.addChild(new PIXI.Text("", {fontFamily: "oswaldregular", fontSize: 58}));

        this._bg = new PIXI.Sprite(PIXI.Texture.BLACK);
        this._bg.width = common.STAGE_WIDTH;
        this._bg.height = common.STAGE_HEIGHT;
        this.addChild(this._bg);

        this._bar = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bar.anchor.set(0, 0.5);
        this._bar.height = 6;
        this._bar.width = 0;
        this._bar.position.set(common.STAGE_WIDTH * 0.5 - this._barWidth * 0.5, common.STAGE_HEIGHT * 0.65);
        //this._bar.tint = 0x0;
        this.addChild(this._bar);

        this._versionButton = P3.Button.create(
            PIXI.Texture.WHITE
        );
        this._versionButton.alpha = 0;
        this._versionButton.animate = false;
        this._versionButton.scale.set(8);
        this._versionButton.y = 0;
        this._versionButton.x = (common.STAGE_WIDTH / 2) - (P3.View.width/2);
        this._versionButton.signals.click.add(() => {
            alert(common.VERSION);
        }, this);
        this.addChild(this._versionButton);

    }

    destroy() {
        // clean up goes here
        super.destroy();
    }

    update() {
        this._bar.width = this.loaded * this._barWidth;

        for(var i in this.fonts)
        {
            if (!this.fonts[i].fontLoaded)
            {
                let w;
                if (this.fonts[i].fontText)
                {
                    w = this.fonts[i].fontText.width;
                }

                this.fonts[i].fontText = new PIXI.Text('Choose Prototype Level', { fontFamily: this.fonts[i].font, fill: 0xFFFFFF });
                if (w && w !== this.fonts[i].fontText.width)
                {
                    this.fonts[i].fontLoaded = true;
                }
            }
        }
    }

    resize()
    {
        this._versionButton.x = (common.STAGE_WIDTH / 2) - (P3.View.width/2);
        super.resize();
    }
}